import React from 'react'
import {Button} from 'reactstrap'
import {AvFeedback, AvForm, AvGroup, AvInput} from 'availity-reactstrap-validation'
import {pageHelpers} from '../pages/'
import CheckIcon from 'react-icons/lib/fa/check'
import EditIcon from 'react-icons/lib/fa/pencil'
import TeamIcon from 'react-icons/lib/fa/group'
import DealerIcon from 'react-icons/lib/fa/building'

class EditableTeamHeader extends React.Component {
    constructor(props) {
        super(props)
        const {teamName, teamIsDealership, onSubmit} = props
        this.state = {
            editing: false,
            teamName,
            teamIsDealership,
            teamNameWidth: 0,
            teamNameHeight: 0,
            editButtonWidth: 0,
        }
        this.onSubmit = onSubmit
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
        this.toggleEditing = this.toggleEditing.bind(this)
    }

    componentDidMount() {
        pageHelpers.setupSingleRunAnimationEvents()
    }

    componentWillUnmount() {
        pageHelpers.tearDownSingleRunAnimationEvents()
    }

    componentWillReceiveProps(nextProps) {
        const {teamName, teamIsDealership, onSubmit} = nextProps
        this.setState({
            teamName,
            teamIsDealership,
        })
        this.onSubmit = onSubmit
    }

    toggleEditing(event) {
        event.preventDefault()
        let {editing} = this.state
        const minTeamNameWidth = 150
        let teamNameWidth = Math.max(document.getElementById('team-name-text').offsetWidth, minTeamNameWidth)
        // Need to add 6px that somehow get magically removed by the DOM
        let teamNameHeight = document.getElementById('team-name-text').offsetHeight + 6
        let editButtonWidth = document.getElementById('edit-team-button').offsetWidth
        this.setState({editing: !editing, teamNameWidth, teamNameHeight, editButtonWidth})
    }

    handleValidSubmit(event, values) {
        event.preventDefault()
        this.setState({editing: false})
        this.onSubmit(event, values)
    }

    render () {
        const {editing, teamName, teamIsDealership, teamNameWidth, teamNameHeight, editButtonWidth} = this.state
        return <div className="col-12 text-center table-head">
            <h2 className="font-weight-bold mb-3">
                {teamIsDealership ? <DealerIcon className="mr-3 light-sf-blue"/> : <TeamIcon className="mr-3 light-sf-blue"/>}
                Manage Team
            </h2>
            {editing ?
                <AvForm onValidSubmit={this.handleValidSubmit}
                        onInvalidSubmit={pageHelpers.handleInvalidFormSubmit}
                        model={{teamName}}
                        className="d-inline-block">
                    <AvGroup className="mb-2">
                        <AvInput name="teamName"
                                 className="d-inline-block mr-3 team-name-input"
                                 type="text"
                                 autoComplete="organization"
                                 style={{width: teamNameWidth, height: teamNameHeight}}
                                 autoFocus
                                 required/>
                        <Button className="bg-success d-inline-block save-team-name-button"
                                style={{width: editButtonWidth}}>
                            <CheckIcon/>
                        </Button>
                        <small><AvFeedback style={{width: teamNameWidth}}>
                            Please enter a team name.
                        </AvFeedback></small>
                    </AvGroup>
                </AvForm> :
                    <div className="pb-2">
                        <h4 id="team-name-text" className="mr-3 d-inline-block">{teamName}</h4>
                        <Button id="edit-team-button"
                                 onClick={this.toggleEditing}>
                            <EditIcon/>
                        </Button>
                    </div>}
        </div>
    }
}

export default EditableTeamHeader


// WEBPACK FOOTER //
// ./src/components/ui/EditableTeamHeader.js